import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const finish = (data) => {
    localStorage.setItem("wt_token", data.access_token);
    const { access_token, ...u } = data;
    setUser(u);
    return u;
  };
  const login = async (email, password) => finish((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) =>
    finish((await api.post("/auth/register", { name, email, password })).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("wt_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
